import b, { useRef as he } from "react";
import { ConditionalRendering as D, ActionIcon as ve, FileButton as be, Button as Y, useCombobox as xe, Combobox as w, TextInput as ge } from "@marketplace/ui";
import './ui.css';var P = { exports: {} }, E = {};
var q;
function _e() {
  if (q) return E;
  q = 1;
  var r = /* @__PURE__ */ Symbol.for("react.transitional.element"), n = /* @__PURE__ */ Symbol.for("react.fragment");
  function t(o, i, l) {
    var d = null;
    if (l !== void 0 && (d = "" + l), i.key !== void 0 && (d = "" + i.key), "key" in i) {
      l = {};
      for (var p in i)
        p !== "key" && (l[p] = i[p]);
    } else l = i;
    return i = l.ref, {
      $$typeof: r,
      type: o,
      key: d,
      ref: i !== void 0 ? i : null,
      props: l
    };
  }
  return E.Fragment = n, E.jsx = t, E.jsxs = t, E;
}
var y = {};
var G;
function je() {
  return G || (G = 1, process.env.NODE_ENV !== "production" && (function() {
    function r(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === de ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case _:
          return "Fragment";
        case oe:
          return "Profiler";
        case ne:
          return "StrictMode";
        case le:
          return "Suspense";
        case ce:
          return "SuspenseList";
        case fe:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case h:
            return "Portal";
          case se:
            return e.displayName || "Context";
          case ae:
            return (e._context.displayName || "Context") + ".Consumer";
          case ie:
            var a = e.render;
            return e = e.displayName, e || (e = a.displayName || a.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case ue:
            return a = e.displayName || null, a !== null ? a : r(e.type) || "Memo";
          case A:
            a = e._payload, e = e._init;
            try {
              return r(e(a));
            } catch {
            }
        }
      return null;
    }
    function n(e) {
      return "" + e;
    }
    function t(e) {
      try {
        n(e);
        var a = !1;
      } catch {
        a = !0;
      }
      if (a) {
        a = console;
        var c = a.error, u = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return c.call(
          a,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          u
        ), n(e);
      }
    }
    function o(e) {
      if (e === _) return "<>";
      if (typeof e == "object" && e !== null && e.$$typeof === A)
        return "<...>";
      try {
        var a = r(e);
        return a ? "<" + a + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var e = z.A;
      return e === null ? null : e.getOwner();
    }
    function l() {
      return Error("react-stack-top-frame");
    }
    function d(e) {
      if (W.call(e, "key")) {
        var a = Object.getOwnPropertyDescriptor(e, "key").get;
        if (a && a.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function p(e, a) {
      function c() {
        $ || ($ = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          a
        ));
      }
      c.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: c,
        configurable: !0
      });
    }
    function m() {
      var e = r(this.type);
      return U[e] || (U[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function C(e, a, c, u, k, I) {
      var f = c.ref;
      return e = {
        $$typeof: v,
        type: e,
        key: a,
        props: c,
        _owner: u
      }, (f !== void 0 ? f : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: m
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(e, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: k
      }), Object.defineProperty(e, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: I
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function O(e, a, c, u, k, I) {
      var f = a.children;
      if (f !== void 0)
        if (u)
          if (me(f)) {
            for (u = 0; u < f.length; u++)
              R(f[u]);
            Object.freeze && Object.freeze(f);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else R(f);
      if (W.call(a, "key")) {
        f = r(e);
        var j = Object.keys(a).filter(function(pe) {
          return pe !== "key";
        });
        u = 0 < j.length ? "{key: someKey, " + j.join(": ..., ") + ": ...}" : "{key: someKey}", J[f + u] || (j = 0 < j.length ? "{" + j.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          u,
          f,
          j,
          f
        ), J[f + u] = !0);
      }
      if (f = null, c !== void 0 && (t(c), f = "" + c), d(a) && (t(a.key), f = "" + a.key), "key" in a) {
        c = {};
        for (var L in a)
          L !== "key" && (c[L] = a[L]);
      } else c = a;
      return f && p(
        c,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), C(
        e,
        f,
        c,
        i(),
        k,
        I
      );
    }
    function R(e) {
      g(e) ? e._store && (e._store.validated = 1) : typeof e == "object" && e !== null && e.$$typeof === A && (e._payload.status === "fulfilled" ? g(e._payload.value) && e._payload.value._store && (e._payload.value._store.validated = 1) : e._store && (e._store.validated = 1));
    }
    function g(e) {
      return typeof e == "object" && e !== null && e.$$typeof === v;
    }
    var x = b, v = /* @__PURE__ */ Symbol.for("react.transitional.element"), h = /* @__PURE__ */ Symbol.for("react.portal"), _ = /* @__PURE__ */ Symbol.for("react.fragment"), ne = /* @__PURE__ */ Symbol.for("react.strict_mode"), oe = /* @__PURE__ */ Symbol.for("react.profiler"), ae = /* @__PURE__ */ Symbol.for("react.consumer"), se = /* @__PURE__ */ Symbol.for("react.context"), ie = /* @__PURE__ */ Symbol.for("react.forward_ref"), le = /* @__PURE__ */ Symbol.for("react.suspense"), ce = /* @__PURE__ */ Symbol.for("react.suspense_list"), ue = /* @__PURE__ */ Symbol.for("react.memo"), A = /* @__PURE__ */ Symbol.for("react.lazy"), fe = /* @__PURE__ */ Symbol.for("react.activity"), de = /* @__PURE__ */ Symbol.for("react.client.reference"), z = x.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, W = Object.prototype.hasOwnProperty, me = Array.isArray, M = console.createTask ? console.createTask : function() {
      return null;
    };
    x = {
      react_stack_bottom_frame: function(e) {
        return e();
      }
    };
    var $, U = {}, H = x.react_stack_bottom_frame.bind(
      x,
      l
    )(), V = M(o(l)), J = {};
    y.Fragment = _, y.jsx = function(e, a, c) {
      var u = 1e4 > z.recentlyCreatedOwnerStacks++;
      return O(
        e,
        a,
        c,
        !1,
        u ? Error("react-stack-top-frame") : H,
        u ? M(o(e)) : V
      );
    }, y.jsxs = function(e, a, c) {
      var u = 1e4 > z.recentlyCreatedOwnerStacks++;
      return O(
        e,
        a,
        c,
        !0,
        u ? Error("react-stack-top-frame") : H,
        u ? M(o(e)) : V
      );
    };
  })()), y;
}
var X;
function we() {
  return X || (X = 1, process.env.NODE_ENV === "production" ? P.exports = _e() : P.exports = je()), P.exports;
}
var s = we(), ee = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, Z = b.createContext && /* @__PURE__ */ b.createContext(ee), Ee = ["attr", "size", "title"];
function ye(r, n) {
  if (r == null) return {};
  var t, o, i = Oe(r, n);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(r);
    for (o = 0; o < l.length; o++) t = l[o], n.indexOf(t) === -1 && {}.propertyIsEnumerable.call(r, t) && (i[t] = r[t]);
  }
  return i;
}
function Oe(r, n) {
  if (r == null) return {};
  var t = {};
  for (var o in r) if ({}.hasOwnProperty.call(r, o)) {
    if (n.indexOf(o) !== -1) continue;
    t[o] = r[o];
  }
  return t;
}
function S() {
  return S = Object.assign ? Object.assign.bind() : function(r) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var o in t) ({}).hasOwnProperty.call(t, o) && (r[o] = t[o]);
    }
    return r;
  }, S.apply(null, arguments);
}
function Q(r, n) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(r);
    n && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function T(r) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Q(Object(t), !0).forEach(function(o) {
      Re(r, o, t[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : Q(Object(t)).forEach(function(o) {
      Object.defineProperty(r, o, Object.getOwnPropertyDescriptor(t, o));
    });
  }
  return r;
}
function Re(r, n, t) {
  return (n = ke(n)) in r ? Object.defineProperty(r, n, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[n] = t, r;
}
function ke(r) {
  var n = Pe(r, "string");
  return typeof n == "symbol" ? n : n + "";
}
function Pe(r, n) {
  if (typeof r != "object" || !r) return r;
  var t = r[Symbol.toPrimitive];
  if (t !== void 0) {
    var o = t.call(r, n);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(r);
}
function re(r) {
  return r && r.map((n, t) => /* @__PURE__ */ b.createElement(n.tag, T({
    key: t
  }, n.attr), re(n.child)));
}
function N(r) {
  return (n) => /* @__PURE__ */ b.createElement(Se, S({
    attr: T({}, r.attr)
  }, n), re(r.child));
}
function Se(r) {
  var n = (t) => {
    var {
      attr: o,
      size: i,
      title: l
    } = r, d = ye(r, Ee), p = i || t.size || "1em", m;
    return t.className && (m = t.className), r.className && (m = (m ? m + " " : "") + r.className), /* @__PURE__ */ b.createElement("svg", S({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, t.attr, o, d, {
      className: m,
      style: T(T({
        color: r.color || t.color
      }, t.style), r.style),
      height: p,
      width: p,
      xmlns: "http://www.w3.org/2000/svg"
    }), l && /* @__PURE__ */ b.createElement("title", null, l), r.children);
  };
  return Z !== void 0 ? /* @__PURE__ */ b.createElement(Z.Consumer, null, (t) => n(t)) : n(ee);
}
function Te(r) {
  return N({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }, child: [] }] })(r);
}
function Ne(r) {
  return N({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" }, child: [] }] })(r);
}
function Ce(r) {
  return N({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z" }, child: [] }] })(r);
}
function Ae(r) {
  return N({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }, child: [] }] })(r);
}
const Ue = ({
  fileValue: r,
  deleteFile: n,
  onChange: t,
  disabled: o,
  loading: i,
  accept: l
}) => {
  const d = he(null), p = () => {
    n && n(), d.current?.();
  };
  return /* @__PURE__ */ s.jsxs("div", { className: "flex justify-center items-center gap-x-[5px]", children: [
    /* @__PURE__ */ s.jsx(D, { condition: !!r, children: /* @__PURE__ */ s.jsx(
      ve,
      {
        disabled: o,
        variant: "transparent",
        onClick: p,
        classNames: {
          root: "!bg-transparent"
        },
        children: /* @__PURE__ */ s.jsx(Ce, { className: "text-[#FF0606]", size: 14 })
      }
    ) }),
    /* @__PURE__ */ s.jsx(
      be,
      {
        resetRef: d,
        onChange: t || (() => {
        }),
        disabled: o,
        accept: l,
        children: (m) => /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
          /* @__PURE__ */ s.jsx(D, { condition: !r, children: /* @__PURE__ */ s.jsx(
            Y,
            {
              size: "sm",
              disabled: o || i,
              className: "rounded",
              ...m,
              children: "Browse"
            }
          ) }),
          /* @__PURE__ */ s.jsx(D, { condition: !!r, children: /* @__PURE__ */ s.jsx(
            Y,
            {
              size: "sm",
              disabled: o || i,
              loading: i,
              rightSection: /* @__PURE__ */ s.jsx(Ae, { className: "text-[#45B527]", size: 14 }),
              className: "rounded flex items-center gap-x-[6px]",
              ...m,
              children: "Selected"
            }
          ) })
        ] })
      }
    )
  ] });
};
function te(r) {
  var n, t, o = "";
  if (typeof r == "string" || typeof r == "number") o += r;
  else if (typeof r == "object") if (Array.isArray(r)) {
    var i = r.length;
    for (n = 0; n < i; n++) r[n] && (t = te(r[n])) && (o && (o += " "), o += t);
  } else for (t in r) r[t] && (o && (o += " "), o += t);
  return o;
}
function B() {
  for (var r, n, t = 0, o = "", i = arguments.length; t < i; t++) (r = arguments[t]) && (n = te(r)) && (o && (o += " "), o += n);
  return o;
}
const ze = "_dropdown_bl6ix_1", Me = "_option_bl6ix_8", Ie = "_active_bl6ix_22", F = {
  dropdown: ze,
  option: Me,
  active: Ie
}, Le = (r) => {
  const {
    ref: n,
    label: t = "filter",
    icon: o,
    rightSection: i,
    leftSection: l,
    onChange: d,
    options: p = [],
    value: m,
    width: C,
    dropdownPosition: O,
    resetable: R,
    buttonProps: g,
    buttonComponent: x
  } = r, v = xe();
  return /* @__PURE__ */ s.jsxs(
    w,
    {
      store: v,
      width: C,
      classNames: {
        dropdown: F.dropdown,
        option: F.option
      },
      onOptionSubmit: (h, _) => {
        d && d(R && h === m ? "" : h, _), v.closeDropdown();
      },
      position: O,
      children: [
        /* @__PURE__ */ s.jsx(w.Target, { ref: n, children: x ? b.createElement(x, {
          ...g,
          type: "button",
          "aria-haspopup": "listbox",
          "aria-expanded": v.dropdownOpened,
          "aria-label": t,
          onClick: () => {
            v.toggleDropdown();
          },
          className: B("cursor-pointer", g?.className)
        }) : /* @__PURE__ */ s.jsx(
          Y,
          {
            rightSection: i,
            leftSection: l,
            type: "button",
            "aria-haspopup": "listbox",
            "aria-expanded": v.dropdownOpened,
            "aria-label": t,
            onClick: () => v.toggleDropdown(),
            ...g,
            children: /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-x-1", children: [
              /* @__PURE__ */ s.jsx("span", { className: "text-fjord-grey-500 text-h-xxs font-semibold", children: t }),
              o
            ] })
          }
        ) }),
        /* @__PURE__ */ s.jsx(w.Dropdown, { children: /* @__PURE__ */ s.jsx(w.Options, { children: p.map((h) => /* @__PURE__ */ s.jsx(
          w.Option,
          {
            value: h.value,
            active: m === h.value,
            className: B(m === h.value && F.active),
            children: h.label
          },
          h.value
        )) }) })
      ]
    }
  );
};
Le.displayName = "FilterButton";
const He = ({ meet: r, label: n }) => /* @__PURE__ */ s.jsxs(
  "div",
  {
    className: B(
      r && "text-[#45B527]",
      !r && "text-[#EF3030]",
      "flex items-center gap-x-1 max-w-[182px]"
    ),
    children: [
      /* @__PURE__ */ s.jsx("div", { className: "h-[14px]", children: r ? /* @__PURE__ */ s.jsx(Ne, {}) : /* @__PURE__ */ s.jsx(Te, {}) }),
      /* @__PURE__ */ s.jsx("div", { className: "text-xs", children: n })
    ]
  }
), De = (r) => /* @__PURE__ */ s.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none",
    viewBox: "0 0 20 20",
    ...r,
    children: /* @__PURE__ */ s.jsx(
      "path",
      {
        stroke: "#6B7B8C",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M17.5 17.5l-5-5m1.667-4.167a5.833 5.833 0 11-11.666 0 5.833 5.833 0 0111.666 0z"
      }
    )
  }
), Ve = (r) => /* @__PURE__ */ s.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    fill: "none",
    viewBox: "0 0 14 14",
    ...r,
    children: [
      /* @__PURE__ */ s.jsx(
        "path",
        {
          fill: "#556272",
          d: "M1.75 5.25l2.333-2.333L6.417 5.25M4.083 2.917v8.166-8.166z"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          stroke: "#556272",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2",
          d: "M1.75 5.25l2.333-2.333m0 0L6.417 5.25M4.083 2.917v8.166"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          fill: "#556272",
          d: "M12.25 8.75l-2.333 2.333L7.584 8.75m2.333 2.333V2.917v8.166z"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          stroke: "#556272",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2",
          d: "M12.25 8.75l-2.333 2.333m0 0L7.584 8.75m2.333 2.333V2.917"
        }
      )
    ]
  }
), Fe = "_search_1189k_1", Ye = "_section_1189k_6", K = {
  search: Fe,
  section: Ye
}, Be = ({
  ref: r,
  className: n,
  placeholder: t = "Search",
  value: o,
  onChange: i
}) => /* @__PURE__ */ s.jsx(
  ge,
  {
    ref: r,
    placeholder: t,
    className: n,
    classNames: {
      input: K.search,
      section: K.section
    },
    rightSection: /* @__PURE__ */ s.jsx(De, {}),
    value: o,
    onChange: (l) => i?.(l.target.value)
  }
);
Be.displayName = "SearchInput";
export {
  Ue as FileButtonInput,
  Le as FilterSelect,
  He as PasswordStrength,
  De as SearchIcon,
  Be as SearchInput,
  Ve as SortIcon
};
